import { createAction } from '@reduxjs/toolkit';

export const counterAction = createAction('COUNTER');
